/**
 * ATHÉR footer: the phone accordions. Each menu heading is a real <button>
 * with aria-expanded and aria-controls, so touch, the keyboard (Enter/Space)
 * and screen readers all work from native behaviour; this only flips the
 * state. data-single="true" keeps one menu open at a time. On wider screens
 * the lists are always shown by CSS and the buttons are not rendered.
 * In the theme editor, selecting a menu block opens it.
 */
class AtherFooter extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#onClick);
    document.addEventListener('shopify:block:select', this.#onBlockSelect);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
    document.removeEventListener('shopify:block:select', this.#onBlockSelect);
  }

  #onClick = (event) => {
    const button = event.target.closest('.ather-footer__toggle');
    if (!button || !this.contains(button)) return;
    this.#set(button, button.getAttribute('aria-expanded') !== 'true');
  };

  #onBlockSelect = (event) => {
    const block = this.querySelector(`[data-block-id="${event.detail.blockId}"]`);
    const button = block && block.querySelector('.ather-footer__toggle');
    if (button) this.#set(button, true);
  };

  #set(button, open) {
    if (open && this.dataset.single === 'true') {
      for (const other of this.querySelectorAll('.ather-footer__toggle[aria-expanded="true"]')) {
        if (other !== button) this.#set(other, false);
      }
    }
    button.setAttribute('aria-expanded', String(open));
    const list = document.getElementById(button.getAttribute('aria-controls'));
    if (list) list.toggleAttribute('data-open', open);
  }
}

if (!customElements.get('ather-footer')) customElements.define('ather-footer', AtherFooter);
